import { NavigationItem } from '../../data/types';
import { Translator } from '../../modules/translate';
import { DataHook } from '../../modules/dataHooks';

import s from './MenuItemsDropdown.scss';

type MenuItemsDropdownProps = {
  id: string;
  items: NavigationItem[];
  t: Translator;
};

export const MenuItemsDropdown = ({ id, items, t }: MenuItemsDropdownProps) => `
  <ul class="${s.list}" data-hook="${DataHook.MenuItemsDropdown}" role="region" aria-labelledby="${id}">
    ${items
      .map(
        ({ name, text: translationKey, href, target }) => `
          <li class="${s.item}">
            <a
              class="${s.link}"
              href="${href}"
              ${target ? `target="${target}"` : ''}
              data-bi-name="${name}"
            >
              ${t(translationKey)}
            </a>
          </li>
        `,
      )
      .join('')}
  </ul>
`;
